// Which item kind a business type leads with when creating a new item.
//
// Lives in its own module rather than in `index.ts` so that `infer.ts` can reach
// it without importing the registry barrel — the barrel re-exports `infer.ts`,
// and a module cycle through a file this low in the stack is not worth the
// convenience of one fewer file.

import type { BusinessTypeId } from '@/lib/business-types/registry';

import { DEFAULT_ITEM_KIND, type ItemKind } from './types';

/**
 * A caterer's "Add item" opens the package editor; everyone else gets a dish.
 * This is a DEFAULT only , any kind is available in any menu (mixed-model), and
 * type never locks the choice (doc 33 preset-vs-override law).
 */
export function defaultItemKindForBusinessType(typeId: string | null | undefined): ItemKind {
  switch (typeId as BusinessTypeId) {
    case 'catering':
      return 'package';
    default:
      return DEFAULT_ITEM_KIND;
  }
}
